import React, { useRef, useState } from 'react';
import Button from '@mui/material/Button';
import { motion, useReducedMotion } from 'framer-motion';

const MotionButton = motion(Button);

// Thin presentational wrapper: every prop (onClick, href, variant, children...)
// passes straight through to MUI Button, so existing CTA behavior is untouched.
export default function MagneticButton({ children, sx, strength = 14, ...props }) {
  const ref = useRef(null);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const prefersReducedMotion = useReducedMotion();

  const handleMouseMove = (e) => {
    if (prefersReducedMotion || !ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const relX = (e.clientX - rect.left - rect.width / 2) / rect.width;
    const relY = (e.clientY - rect.top - rect.height / 2) / rect.height;
    setOffset({ x: relX * strength, y: relY * strength });
  };

  const handleMouseLeave = () => setOffset({ x: 0, y: 0 });

  return (
    <MotionButton
      ref={ref}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      animate={{ x: offset.x, y: offset.y }}
      transition={{ type: 'spring', stiffness: 200, damping: 15, mass: 0.4 }}
      whileHover={prefersReducedMotion ? undefined : { scale: 1.04 }}
      whileTap={prefersReducedMotion ? undefined : { scale: 0.97 }}
      sx={{
        boxShadow: '0 8px 24px rgba(253,129,18,0.35)',
        transition: 'box-shadow 0.3s ease',
        '&:hover': { boxShadow: '0 14px 32px rgba(253,129,18,0.5)' },
        ...sx,
      }}
      {...props}
    >
      {children}
    </MotionButton>
  );
}
